import { useEffect, useState } from "react";
import TPC_URL from "../../../utils/TPC_URL";
import axios from "axios";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

function StockOutModal({ open, onClose, openSnackbar, setUpdateStatus }) {
  const { group_code, project_code } = useParams();
  const [items, setItems] = useState([]);
  const [formData, setFormData] = useState({
    item_name: "",
    quantity: "",
  });
  const [errors, setErrors] = useState({
    item_name: "",
    quantity: "",
  });

  useEffect(() => {
    async function fetchData() {
      try {
        const itemRes = await axios.get(
          TPC_URL +
            `/api/item/getAllItems?group_code=${group_code}&project_code=${project_code}`
        );
        setItems(itemRes.data || []);
      } catch (e) {
        console.log(e);
        openSnackbar("데이터를 불러오지 못했습니다.", "error");
      }
    }
    if (open) {
      fetchData();
    }
  }, [open, group_code, project_code, openSnackbar]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    validateField(name, value);
  };

  const handleItemChange = (event, newValue) => {
    setFormData({
      ...formData,
      item_name: newValue ? newValue.item_name : "",
    });
    validateField("item_name", newValue ? newValue.item_name : "");
  };

  const validateField = (name, value) => {
    let errorMessage = "";
    switch (name) {
      case "item_name":
        errorMessage = value ? "" : "제품명을 선택해주세요.";
        break;
      case "quantity":
        if (!value) {
          errorMessage = "수량을 입력해주세요.";
        } else if (
          isNaN(value) ||
          parseInt(value) <= 0 ||
          !Number.isInteger(Number(value))
        ) {
          errorMessage = "수량은 0보다 큰 정수여야 합니다.";
        }
        break;
      default:
        break;
    }
    setErrors({
      ...errors,
      [name]: errorMessage,
    });

    return errorMessage === "";
  };

  const validateForm = () => {
    const validItem = validateField("item_name", formData.item_name);
    const validQuantity = validateField("quantity", formData.quantity);
    return validItem && validQuantity;
  };

  const handleSubmit = async () => {
    try {
      if (validateForm()) {
        const param = {
          group_code,
          project_code,
          item_name: formData.item_name,
          qty: parseInt(formData.quantity),
        };

        const res = await axios.post(
          TPC_URL + "/api/stock/postStockOut",
          param
        );

        if (res.status === 200) {
          openSnackbar("출고 정보가 등록되었습니다.", "success");
          handleClose();
          setUpdateStatus((prev) => !prev);
        }
      } else {
        openSnackbar("입력 내용을 확인해주세요.", "error");
      }
    } catch (e) {
      console.log(e);
      openSnackbar("오류가 발생했습니다.", "error");
    }
  };

  const handleClose = () => {
    setFormData({
      item_name: "",
      quantity: "",
    });
    setErrors({
      item_name: "",
      quantity: "",
    });
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="stock-out-modal-title"
      aria-describedby="stock-out-modal-description"
    >
      <Box sx={modalStyle}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography
            id="stock-out-modal-title"
            variant="h6"
            component="h2"
            color="#ff8787"
          >
            출고 등록
          </Typography>
          <IconButton onClick={handleClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Autocomplete
              id="item-select"
              options={items}
              getOptionLabel={(option) =>
                `${option.material_grouping} - ${option.item_name}`
              }
              onChange={handleItemChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="제품명"
                  name="item_name"
                  error={!!errors.item_name}
                  helperText={errors.item_name}
                  fullWidth
                  required
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="수량"
              name="quantity"
              type="number"
              value={formData.quantity}
              onChange={handleChange}
              error={!!errors.quantity}
              helperText={errors.quantity}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">EA</InputAdornment>
                ),
              }}
              fullWidth
              required
              inputProps={{
                min: 1,
                step: 1,
              }}
            />
          </Grid>
          <Grid item xs={12} mt={2} display="flex" justifyContent="flex-end">
            <Button variant="outlined" onClick={handleClose} sx={{ mr: 1 }}>
              취소
            </Button>
            <Button
              variant="contained"
              onClick={handleSubmit}
              sx={{
                bgcolor: "#ff8787",
                "&:hover": {
                  bgcolor: "#d17777",
                },
              }}
            >
              출고
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}

export default StockOutModal;
